import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { API } from "@/lib/api";

/** Global hook mounted once from AppShell.
 *  Subscribes to the existing Kippu notifications SSE stream and, when a
 *  Genesys screen-pop payload arrives (`kind === "genesys_screen_pop"`),
 *  navigates the agent to that lead with a toast.
 *  Falls back silently when SSE is unavailable — the LeadDetail badge and
 *  ws-status endpoint surface the degradation.
 */
export default function useGenesysScreenPop() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("kippu_token");
    if (!token) return undefined;
    let es;
    try {
      es = new EventSource(`${API}/notifications/stream?token=${encodeURIComponent(token)}`);
    } catch (_) {
      return undefined;
    }
    const onMsg = (ev) => {
      if (!ev?.data) return;
      let payload;
      try { payload = JSON.parse(ev.data); } catch (_) { return; }
      if (payload?.kind !== "genesys_screen_pop") return;
      const leadId = payload.lead_id;
      if (!leadId) return;
      const conv = payload.conversation_id ? `&conversation=${encodeURIComponent(payload.conversation_id)}` : "";
      toast.info(
        `Screen-pop · ${payload.customer_name || payload.customer_id || "lead"}${payload.phone ? ` · ${payload.phone}` : ""}`,
      );
      navigate(`/leads/${leadId}?src=genesys${conv}`);
    };
    es.addEventListener("message", onMsg);
    return () => {
      es.removeEventListener("message", onMsg);
      es.close();
    };
  }, [navigate]);
}
